import { render, staticRenderFns } from "./BasketMobile.vue?vue&type=template&id=17106e00&scoped=true&"
import script from "./BasketMobile.vue?vue&type=script&lang=js&"
export * from "./BasketMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17106e00",
  null
  
)

export default component.exports